import { IPaginationQuery } from '../../models';

const apiHost = process.env.REACT_APP_API_BASE_URL || '';
export const baseApiPath = `${apiHost}/api`;

export const moduleAdminPath = '/admin';
export const moduleSurveyPath = '/survey';

export const phoneNumberMask = '(999) 999-9999-99999';

export const deleteFilePath = '/clients/file';

export const noData = '--';
export const noNumeralData = 0;

export const defaultRangeMax = 100;

export const allOptionsCheckbox = 'all';
export const NONE = 'NONE';

export const tablePaginationDefaultValues: IPaginationQuery = {
	page: 0,
	size: 8,
};

export const minuteIntervalInMs = 60000;
